import jQuery from 'jquery';

jQuery(function($) {
  let $order = $('.order');

  // Вкладки заказов
  let $orderTabs = $order.find('.order__list');
  let $orderTabTitles = $order.find('.order__tab-title');

  $orderTabTitles.on('click', function() {
    let $orderTabTitle = $(this);
    let $orderTab = $orderTabs.filter(function() {
      return $(this).data('tab') === $orderTabTitle.data('tab');
    });

    $orderTabs.addClass('d-none');
    $orderTab.removeClass('d-none');

    $orderTabTitles.removeClass('order__tab-title--active');
    $orderTabTitle.addClass('order__tab-title--active');

    localStorage.setItem('order-tab', $(this).data('tab'));
  });

  // Восстановление вкладки при перезагрузке
  if (localStorage.getItem('order-tab')) {
    let $targetTab = $orderTabTitles.filter(function() {
      return $(this).data('tab') === localStorage.getItem('order-tab');
    });

    $targetTab.trigger('click');
  }

  // Фильтрация и сортировка заказов
  let $form = $order.find('#filter-sort');
  let $filterYear = $form.find('#filter-year');
  let $filterMonth = $form.find('#filter-month');
  let $sort = $form.find('#sort');
  let $selects = $([]).add($filterYear).add($filterMonth).add($sort);

  // Сохранение значения и отправка формы при изменении значения селекта.
  $selects.on('change', function() {
    let $select = $(this);

    if (localStorage.getItem($select.prop('name')) === $select.val()) {
      return;
    }

    localStorage.setItem($select.prop('name'), $select.val());
    $form.trigger('submit');
  });

  // Восстановление фильтров и сортировки при перезагрузке
  $selects.each(function() {
    let $select = $(this);
    let storedValue = localStorage.getItem($select.prop('name'));

    if (storedValue) {
      $select.val(storedValue);
    }
  });

  // Статус заказа
  let $orderItems = $order.find('.order__item');
  $orderItems.each(function() {
    let $orderItem = $(this);
    let $orderStatus = $orderItem.find('.order__status-text--get-status');

    $orderStatus.one('click', function() {
      $orderStatus.html('<div role="status" class="order__spinner spinner-border text--main2"></div>');

      $.ajax({
        url: '/lk/get-status',
        method: 'GET',
        data: {
          orderId: $orderItem.data('orderId'),
        },
      }).done(function(html) {
        $orderStatus.html(html);
      });
    });
  });
});
